import { TextFieldProps, TextField, InputAdornment } from '@mui/material';
import { useEffect, useState } from 'react';
import { MdOutlineSearch } from 'react-icons/md';

interface Props extends Omit<TextFieldProps, 'name'> {
  name?: string;
  debounceTime?: number;
  searchText: null | string;
  setSearchText: (value: string | null) => void;
}

export default function Search({
  name = 'search',
  debounceTime = 800,
  searchText = '',
  setSearchText,
  ...inputFieldProps
}: Props) {
  const [value, setValue] = useState<null | string>(searchText);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText(value);
    }, debounceTime);

    return () => {
      clearTimeout(timer);
    };
  }, [value, setSearchText, debounceTime]);

  return (
    <TextField
      {...inputFieldProps}
      value={value || ''}
      onChange={(e) => setValue(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position='start'>
              <MdOutlineSearch />
            </InputAdornment>
          )
        }
      }}
    />
  );
}
